import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMozillaComponent } from './simple-icons-mozilla.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMozillaComponent ],
    exports:      [ SimpleIconsMozillaComponent ],
    bootstrap:    []
})
export class SimpleIconsMozillaModule {}
